/* tslint:disable */
/* eslint-disable */
//----------------------
// <auto-generated>
//     Generated with ApiClientGenerator, using the NSwag toolchain
// </auto-generated>
//----------------------
// ReSharper disable InconsistentNaming

import axios, { AxiosRequestConfig, AxiosPromise, AxiosInstance, CancelToken } from 'axios';
import { injectable, inject, optional, symbolToken } from '@servicetitan/react-ioc';
// @ts-ignore: needed for Date serialization if a DateTime parameter has an Unspecified attribute on it
import moment from 'moment';

export interface ILogoApi {
    upload(brandId: string, file: FileParameter | undefined, cancelToken?: CancelToken): AxiosPromise<string>;
    copy(command: CopyLogoRequest, cancelToken?: CancelToken): AxiosPromise<void>;
    checkIfLogoExists(brandId: string, cancelToken?: CancelToken): AxiosPromise<boolean>;
    getAsUrl(brandId: string, cancelToken?: CancelToken): AxiosPromise<string>;
}

interface ClientApiConfig {
    baseUrl: string;
    axios: AxiosInstance;
}

export const BASE_URL_TOKEN_LogoApi = symbolToken<string>('BASE_URL_TOKEN', false);
export const AXIOS_TOKEN_LogoApi = symbolToken<string>('AXIOS_TOKEN', false);

@injectable()
export class LogoApi implements ILogoApi {
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;
    protected readonly opts: ClientApiConfig;

    constructor(
        @inject(BASE_URL_TOKEN_LogoApi) @optional() baseUrl = '',
        @inject(AXIOS_TOKEN_LogoApi) @optional() axiosInstance = axios,
    ) {

        this.opts = {
            baseUrl,
            axios: axiosInstance,
        };
    }

    upload(brandId: string, file: FileParameter | undefined, cancelToken?: CancelToken): AxiosPromise<string> {
        let url_ = "/marketing/api/brands/Logo/upload?";
        if (brandId === undefined || brandId === null)
            throw new Error("The parameter 'brandId' must be defined and cannot be null.");
        else
            url_ += "brandId=" + encodeURIComponent("" + brandId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (file === null || file === undefined)
            throw new Error("The parameter 'file' cannot be null.");
        else
            content_.append("file", file.data, file.fileName ? file.fileName : "file");

        let options_ = <AxiosRequestConfig>{
            baseURL: this.opts.baseUrl,
            cancelToken,
            data: content_,
            url: url_,
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.opts.axios.request<string>(options_);
    }

    copy(command: CopyLogoRequest, cancelToken?: CancelToken): AxiosPromise<void> {
        let url_ = "/marketing/api/brands/Logo/copy";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = command;

        let options_ = <AxiosRequestConfig>{
            baseURL: this.opts.baseUrl,
            cancelToken,
            data: content_,
            url: url_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.opts.axios.request<void>(options_);
    }

    checkIfLogoExists(brandId: string, cancelToken?: CancelToken): AxiosPromise<boolean> {
        let url_ = "/marketing/api/brands/Logo/exists?";
        if (brandId === undefined || brandId === null)
            throw new Error("The parameter 'brandId' must be defined and cannot be null.");
        else
            url_ += "brandId=" + encodeURIComponent("" + brandId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            baseURL: this.opts.baseUrl,
            cancelToken,
            url: url_,
            method: "GET",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.opts.axios.request<boolean>(options_);
    }

    getAsUrl(brandId: string, cancelToken?: CancelToken): AxiosPromise<string> {
        let url_ = "/marketing/api/brands/Logo?";
        if (brandId === undefined || brandId === null)
            throw new Error("The parameter 'brandId' must be defined and cannot be null.");
        else
            url_ += "brandId=" + encodeURIComponent("" + brandId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            baseURL: this.opts.baseUrl,
            cancelToken,
            url: url_,
            method: "GET",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.opts.axios.request<string>(options_);
    }
}

export interface CopyLogoRequest {
    sourceId: string;
    destinationId: string;
}

export interface FileParameter {
    data: any;
    fileName: string;
}
